import { type CSATRating } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { WORK_EXPERIENCE_FEEDBACK_SUBMITTED_KEY } from '../../../contracts/keys';

/**
 * Work Experience Feedback Atoms
 *
 * UMUX-Lite nudge for Work (projects chat). Mirrors Evidence experience feedback
 * with separate localStorage keys so the two products don't share dismiss state.
 * Package-owned and published through no door: the two feedback hooks are the
 * only readers. The submitted key is contract, because e2e writes it too.
 */

const SNOOZE_COUNT_KEY = 'heidi:work-experience-feedback-snooze-count';

export const WORK_TRIGGER_QUERY_COUNT = 2;

export const workExperienceFeedbackSubmittedAtom = atomWithStorage<boolean>(
  WORK_EXPERIENCE_FEEDBACK_SUBMITTED_KEY,
  false
);

export const workExperienceFeedbackSnoozeCountAtom = atomWithStorage<number>(
  SNOOZE_COUNT_KEY,
  0
);

export const workExperienceFeedbackVisibleAtom = atom<boolean>(false);

export const workExperienceFeedbackRatingAtom = atom<CSATRating | null>(null);

export const workExperienceFeedbackUsefulnessRatingAtom = atom<CSATRating | null>(null);

export const workExperienceFeedbackDetailAtom = atom<string>('');

export const workExperienceFeedbackTriggeredThisSessionAtom = atom<boolean>(false);

export const workExperienceFeedbackRatingSubmittedAtom = atom<boolean>(false);

export const workExperienceFeedbackEligibleAtom = atom((get) => {
  const hasSubmitted = get(workExperienceFeedbackSubmittedAtom);
  const snoozeCount = get(workExperienceFeedbackSnoozeCountAtom);
  return !hasSubmitted && snoozeCount < 3;
});

export const workExperienceFeedbackSnoozeAtom = atom(null, (get, set) => {
  const currentCount = get(workExperienceFeedbackSnoozeCountAtom);
  set(workExperienceFeedbackSnoozeCountAtom, currentCount + 1);
  set(workExperienceFeedbackVisibleAtom, false);
  set(workExperienceFeedbackTriggeredThisSessionAtom, true);
});

export const workExperienceFeedbackMarkSubmittedAtom = atom(null, (_, set) => {
  set(workExperienceFeedbackSubmittedAtom, true);
  set(workExperienceFeedbackVisibleAtom, false);
});

export const workExperienceFeedbackDismissAtom = atom(null, (_, set) => {
  set(workExperienceFeedbackVisibleAtom, false);
  set(workExperienceFeedbackTriggeredThisSessionAtom, true);
});

export const workExperienceFeedbackShowAtom = atom(null, (_, set) => {
  set(workExperienceFeedbackVisibleAtom, true);
  set(workExperienceFeedbackTriggeredThisSessionAtom, true);
});

export const workExperienceFeedbackResetFormAtom = atom(null, (_, set) => {
  set(workExperienceFeedbackRatingAtom, null);
  set(workExperienceFeedbackUsefulnessRatingAtom, null);
  set(workExperienceFeedbackDetailAtom, '');
  set(workExperienceFeedbackRatingSubmittedAtom, false);
});
